<mat-icon class="status" [svgIcon]="value ? AppIcon.ACTIVE : AppIcon.INACTIVE"></mat-icon>
